var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-flex gap-6"},[(_vm.isPartner && _vm.isDropdownView)?_c('Type',{attrs:{"type":_vm.type}}):_vm._e(),_c('p',{staticClass:"p-base-light"},[_vm._v(" "+_vm._s(_vm.formatDate(_vm.date))+" ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }